import { useInView } from "react-intersection-observer";

const useTextAnimation = (
    threshold = 0.3,
    triggerOnce = true,
    baseDelayMultiplier = 0.15
) => {
    const { ref, inView } = useInView({
        threshold: window.innerWidth < 768 ? 0.2 : threshold, // Smaller threshold for mobile
        triggerOnce,
    });

    const delayMultiplier = window.innerWidth < 768 ? baseDelayMultiplier / 2 : baseDelayMultiplier;

    const textAnimation = {
        hidden: { y: "100%", opacity: 0 },
        visible: (i) => ({
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.75,
                ease: [0.33, 1, 0.68, 1],
                delay: i * delayMultiplier,  // Adding delay based on index (i)
            },
        }),
    };

    return { ref, inView, textAnimation };
};

export default useTextAnimation;
